import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { SubMenuItemsType } from "@/types/menu";
import { cn } from "@/lib/utils";

const splitPointForLongListMenu = 5;

const ListIconItem1Col = ({ items }: { items: SubMenuItemsType }) => {
  if (!items?.items || items.items.length === 0) return null;

  return (
    <>
      {items?.label && (
        <div className="paragraph-sm text-muted-foreground pb-4 px-4">{items?.label}</div>
      )}
      <div>
        <div className="flex flex-col gap-2">
          {items?.items?.map((item, index) => (
            <NavigationMenuLink asChild key={`col1-${index}`}>
              <a
                className="flex flex-row items-center gap-4 rounded-md px-4 py-4 leading-none no-underline transition-colors outline-none select-none hover:bg-muted hover:text-accent-foreground dark:hover:bg-background"
                href={item.link}
              >
                {item?.hasIcon && item?.icon && (
                  <div className="rounded-md border shadow-sm w-14 h-14 flex items-center justify-center shrink-0">
                    <span className="material-symbols-outlined w-5 h-5 text-transparent bg-clip-text bg-[image:var(--color-gradient-primary)] size-5 !text-xl/5">
                      {item.icon}
                    </span>
                  </div>
                )}
                <div className="flex flex-col justify-center gap-1">
                  {item.title && 
                    item?.hasSuffixIcon && item?.suffixIcon ? (
                      <span className="flex flex-row items-center gap-2">
                        <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                        <span className="material-symbols-outlined !text-[20px] text-muted-foreground">
                          {item.suffixIcon}
                        </span>
                      </span>
                    ) : (
                      <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                    )
                  }
                  {item.subtitle && (
                    <p className="paragraph-sm text-muted-foreground">
                      {item.subtitle}
                    </p>
                  )}
                </div>
               
              </a>
            </NavigationMenuLink>
          ))}
        </div>
      </div>
    </>
  );
};

ListIconItem1Col.displayName = 'NavListIconItem1Col';

const ListIconItem2Col = ({ items }: { items: SubMenuItemsType }) => {
  if (!items?.items || items.items.length === 0) return null;

  const firstColumn = items.items.slice(0, 4);
  const secondColumn = items.items.slice(4);

  return (
    <>
      {items?.label && (
        <div className="paragraph-sm text-muted-foreground pb-4 px-4">{items?.label}</div>
      )}
      <div className={`${secondColumn.length > 0 ? 'grid grid-cols-1 sm:grid-cols-2 gap-4' : ''}`}>
        {/* First Column */}
        <div className="flex flex-col gap-2">
          {firstColumn.map((item, index) => (
            <NavigationMenuLink asChild key={`col1-${index}`}>
              <a
                className="flex flex-row items-center gap-4 rounded-md px-4 py-4 leading-none no-underline transition-colors outline-none select-none hover:bg-muted hover:text-accent-foreground dark:hover:bg-background"
                href={item.link}
              >
                {item?.hasIcon && item?.icon && (
                  <div className="rounded-md border shadow-sm w-14 h-14 flex items-center justify-center shrink-0">
                    <span className="material-symbols-outlined w-5 h-5 text-transparent bg-clip-text bg-[image:var(--color-gradient-primary)] size-5 !text-xl/5">
                      {item.icon}
                    </span>
                  </div>
                )}
                <div className="flex flex-col justify-center gap-1">
                  {item.title && 
                    item?.hasSuffixIcon && item?.suffixIcon ? (
                      <span className="flex flex-row items-center gap-2">
                        <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                        <span className="material-symbols-outlined !text-[20px] text-muted-foreground">
                          {item.suffixIcon}
                        </span>
                      </span>
                    ) : (
                      <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                    )
                  }
                  {item.subtitle && (
                    <p className="paragraph-sm text-muted-foreground">
                      {item.subtitle}
                    </p>
                  )}
                </div>
              </a>
            </NavigationMenuLink>
          ))}
        </div>

        {/* Second Column */}
        {secondColumn.length > 0 && (
          <div className="flex flex-col gap-2">
            {secondColumn.map((item, index) => (
              <NavigationMenuLink asChild key={`col2-${index}`}>
                <a
                  className="flex flex-row items-center gap-4 rounded-md px-4 py-4 leading-none no-underline transition-colors outline-none select-none hover:bg-muted hover:text-accent-foreground dark:hover:bg-background"
                  href={item.link}
                >
                  {item?.hasIcon && item?.icon && (
                    <div className="rounded-md border shadow-sm w-14 h-14 flex items-center justify-center shrink-0">
                      <span className="material-symbols-outlined w-5 h-5 text-transparent bg-clip-text bg-[image:var(--color-gradient-primary)] size-5 !text-xl/5">
                        {item.icon}
                      </span>
                    </div>
                  )}
                  <div className="flex flex-col justify-center gap-1">
                    {item.title && 
                      item?.hasSuffixIcon && item?.suffixIcon ? (
                        <span className="flex flex-row items-center gap-2">
                          <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                          <span className="material-symbols-outlined !text-[20px] text-muted-foreground">
                            {item.suffixIcon}
                          </span>
                        </span>
                      ) : (
                        <span className={cn("paragraph-base", item.subtitle ? "font-bold" : "")}>{item.title}</span>
                      )
                    }
                    {item.subtitle && (
                      <p className="paragraph-sm text-muted-foreground">
                        {item.subtitle}
                      </p>
                    )}
                  </div>
                </a>
              </NavigationMenuLink>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

ListIconItem2Col.displayName = 'NavListIconItem2Col';

export const ListIconItem = ({ items }: { items: SubMenuItemsType }) => {
  if (!items?.items || items.items.length === 0) return null;

  return (
    <div className="flex-1">
      {items.items.length > splitPointForLongListMenu ? (
        <ListIconItem2Col items={items} />
      ) : (
        <ListIconItem1Col items={items} />
      )}
    </div>
  );
};

ListIconItem.displayName = 'NavListIconItem'; 